exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kivra-button>button {\n  max-width: 100%;\n  border-radius: 26.5px;\n  outline: none;\n  font-weight: bold;\n  background-color: #D0EDAD;\n  border-color: #D0EDAD;\n}\n\n.kivra-button_green>button {\n  background-color: #D0EDAD;\n  border-color: #D0EDAD;\n}\n\n.kivra-button_white>button {\n  background-color: #fff;\n  border-color: #fff;\n}\n\n", ""]);

// exports
